import { render, staticRenderFns } from "./BindCardPopup.vue?vue&type=template&id=a34ff286"
import script from "./BindCardPopup.vue?vue&type=script&lang=js"
export * from "./BindCardPopup.vue?vue&type=script&lang=js"
import style0 from "./BindCardPopup.vue?vue&type=style&index=0&id=a34ff286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports